import React, { Component } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

export class ConfirmationModal extends Component {
  state = { modalOpen: false };

  handleOpen = () => this.setState({ modalOpen: true });

  cancelClicked = () => this.setState({ modalOpen: false });
  confirmClicked = () => {
    this.setState({ modalOpen: false });
    this.props.onOkClicked();
  };

  componentDidMount() {
    if (typeof this.props.init === "function") {
      this.props.init();
    }
  }

  triggerFromProps = props => ({ ...this.props.trigger, props: { ...this.props.trigger.props, onClick: this.handleOpen } });

  defaultButtonConfig = {
    confirm: {
      text: "Yes",
      color: "green",
      showButtonsIcons: true,
      icon: "checkmark",
      dataTest: "yesBtn",
      className: ""
    },
    cancel: {
      text: "Cancel",
      color: "red",
      showButtonsIcons: true,
      icon: "remove",
      dataTest: "noBtn",
      className: ""
    }
  };

  buttonsConfig = this.props.config ? this.props.config : this.defaultButtonConfig;

  render() {
    const trigger = this.props.trigger ? (
      this.triggerFromProps()
    ) : (
      <Button
        disabled={this.props.disableModalOpenButton}
        as="span"
        onClick={this.handleOpen}
        className={this.props.buttonClassName}
        data-test={this.props.dataTest}
      >
        {this.props.butttonLabel || "Show Confirmation Modal"}
      </Button>
    );

    return (
      <Modal
        trigger={trigger}
        open={this.state.modalOpen}
        onClose={this.handleClose}
        size={this.props.modalSize || "small"}
        centered={this.props.modalCentered || true}
        {...{ "data-test": this.props.dataTest }}
      >
        <Header content={this.props.header || "Confirm"} />
        <Modal.Content>{this.props.content || "Are you sure?"}</Modal.Content>
        <Modal.Actions>
          {Object.entries(this.buttonsConfig).map(([name, config], index) => {
            return (
              <Button
                key={index}
                color={config.color}
                className={config.className}
                onClick={config.onClick || this[`${name}Clicked`]}
                {...{ "data-test": config.dataTest }}
              >
                {config.showButtonsIcons && <Icon name={config.icon} />}
                {config.text}
              </Button>
            );
          })}
        </Modal.Actions>
      </Modal>
    );
  }
}
